if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          setTimeout(() => {
            this.cart.setActiveElement(document.activeElement);
          }, "500");
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;

            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              const cartDrawerElem = document.querySelector("cart-drawer");
              const threshhold_price = parseInt(cartDrawerElem.getAttribute('data-threshhold-price'), 10);

              fetch('/cart.js')
                .then(res => res.json())
                .then(cart => {
                  Promise.all(cart.items.map(item => {
                    return fetch(`/products/${item.handle}.js`)
                      .then(res => res.json())
                      .then(product => ({
                        qualifies: product.tags.includes('location_xape'),
                        price: item.final_line_price
                      }))
                      .catch(() => ({ qualifies: false, price: 0 }));
                  })).then(results => {
                    const totalQualifiedPrice = results.reduce((sum, { qualifies, price }) => qualifies ? sum + price : sum, 0);
                    console.log("Qualified total:", totalQualifiedPrice);

                    if (totalQualifiedPrice >= threshhold_price) {
                      // Check if free product already exists
                      let freeProductAdded = false;
                      let cartItemElements = document.querySelector('.cart-drawer').querySelectorAll('.cart-item');
                      cartItemElements.forEach((cartItemElement) => {
                        if (cartItemElement.classList.contains("free-product")) {
                          freeProductAdded = true;
                        }
                      });

                      if (!freeProductAdded) {
                        const freeProductForm = document.getElementById("freeProduct__form");
                        if (freeProductForm) {
                          this.insertFreeProduct(freeProductForm);
                        } else {
                          this.cart.renderContents(response);
                        }
                      } else {
                        this.cart.renderContents(response);
                      }
                    } else {
                      this.cart.renderContents(response);
                    }
                  });
                });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      insertFreeProduct(freeProductForm) {
        const config2 = fetchConfig("javascript");
        config2.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config2.headers["Content-Type"];

        const formData2 = new FormData(freeProductForm);
        if (this.cart) {
          formData2.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData2.append("sections_url", window.location.pathname);
        }
        config2.body = formData2;

        fetch(`${routes.cart_add_url}`, config2)
          .then((data) => data.json())
          .then((data) => {
            console.log("Free product added successfully:", data);
            if (this.cart) {
              this.cart.renderContents(data);
            }
          })
          .catch((error) => {
            console.error("Error adding free product:", error);
          });
      }
    }
  );
}
